import { formatPriceWithSeparator } from '@/helpers/price';
import { _t } from '@/locale';
import { PriceType } from './ServiceListCard.types';

const baseTranslationKey = 'components.elements.Card.ServiceCard';

export const getFormattedPrice = ({
  value,
  type,
  isMobileView,
  hasDiscounts = false,
  hidePriceLabel = false,
}: {
  value: number[];
  type: PriceType;
  isMobileView: boolean;
  hasDiscounts?: boolean;
  hidePriceLabel?: boolean;
}) => {
  switch (type) {
    case 'from':
      // Desktop normally carries "from" via the standalone label; when that's hidden, inline the
      // abbreviation so a "from" price still reads as one rather than a fixed price.
      return `${isMobileView || hasDiscounts || hidePriceLabel ? _t('Fr.') : ''} ${formatPriceWithSeparator(
        value[0],
      )} ${_t('kr')}`;
    case 'standard':
      return `${formatPriceWithSeparator(value[0])} ${_t('kr')}`;
    case 'free':
      return _t('Free');
    case 'range':
      return `${formatPriceWithSeparator(value[0])} - ${formatPriceWithSeparator(value[1])} ${_t('kr')}`;
    case 'optional':
      return isMobileView ? _t('salonGiftCardDescription') : _t(`${baseTranslationKey}.price.optional`);
    default:
      return '';
  }
};

export const getFormattedDiscountedPrice = (
  hasDiscounts: boolean,
  price: { type: PriceType; value: number[] },
  discounts: number[],
  isMobileView: boolean,
) => {
  const validPriceTypeForDiscount = getValidPriceTypeForDiscount(price, discounts);

  if (hasDiscounts && validPriceTypeForDiscount && price?.type !== 'variable') {
    return getFormattedPrice({
      type: price.type,
      value: [
        price?.value[0] - discounts[0],
        ...(price.type === 'range' && discounts[1] ? [price?.value[1] - discounts[1]] : []),
      ],
      isMobileView: isMobileView,
      hasDiscounts: true,
    });
  }

  if (price?.type === 'variable') {
    return !isMobileView ? _t('campaignOffer') : _t(`${baseTranslationKey}.price.campaignNoPrice`);
  }
};

export const getValidPriceTypeForDiscount = (price?: { type: PriceType; value: number[] }, discounts?: number[]) => {
  return (
    price?.type === 'from' ||
    price?.type === 'standard' ||
    (price?.type === 'range' && price?.value?.length > 1 && discounts?.length > 1) ||
    price?.type === 'variable'
  );
};

export const getPriceLabel = (type: PriceType, hasDiscounts: boolean) => {
  switch (type) {
    case 'free':
    case 'range':
    case 'standard':
      return _t('price');
    case 'from':
      return _t(`${baseTranslationKey}.price.label.from`);
    case 'optional':
      return _t(`${baseTranslationKey}.price.label.optional`);
    case 'variable':
      return hasDiscounts ? _t(`${baseTranslationKey}.price.label.variable`) : '';
    default:
      return '';
  }
};
